import { Component, ElementRef, ViewChild } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { TAB } from '@angular/cdk/keycodes';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { MatChipInputEvent } from '@angular/material/chips';
import { MatLegacyAutocompleteSelectedEvent as MatAutocompleteSelectedEvent } from '@angular/material/legacy-autocomplete';
import { debounceTime, switchMap } from 'rxjs';

import isArray from 'lodash-es/isArray';
import { AccountService } from 'app/core';
import { Dictionary } from '@shared/models';
import { RelatedToType } from '@shared/enums';
import { FormFieldComponent } from '../form-field.types';

@Component({
  templateUrl: './tags-form-field.component.html',
  styleUrls: ['./tags-form-field.component.scss'],
})
export class TagsFormFieldComponent extends FormFieldComponent {
  @ViewChild('tagInput') tagInput: ElementRef<HTMLInputElement>;

  public editing: boolean = false;
  public value: string = '';
  public tags: string[] = [];
  public foundTags: Dictionary<number>;
  public tagCtrl = new UntypedFormControl();
  public separatorKeysCodes: number[] = [TAB];

  constructor(private _accountService: AccountService) {
    super();
  }

  ngOnInit() {
    this.value = this.fieldDef.meta?.value_hidden && !this.editing ? 'REDACTED' : this.model[this.fieldDef.name];

    if (this.value) this.tags = isArray(this.value) ? this.value : this.value?.split(',');

    this.tagCtrl.valueChanges
      .pipe(
        takeUntilDestroyed(this.dRef),
        debounceTime(400),
        switchMap((value: string) => this._accountService.getAccountTags(RelatedToType.Project, value)),
      )
      .subscribe((tags) => {
        this.foundTags = tags;
      });
  }

  edit(): void {
    if (!this.editing && !this.isDisabled) this.editing = true;
  }

  onBlur(): void {
    this.onSave();
    this.editing = false;
  }

  private onSave(): void {
    this.updateModel();
    this.update.emit({ [this.fieldDef.name]: this.value ? this.value : [] });
  }

  private updateModel(): void {
    this.model[this.fieldDef.name] = this.value;
  }

  addTag(event: MatChipInputEvent): void {
    const input = event.chipInput.inputElement;

    if ((input.value || '').trim()) this.tags.push(input.value.trim());

    if (input) input.value = '';

    this.tagCtrl.setValue(null);
  }

  removeTag(tag: string): void {
    this.tags.splice(
      this.tags.findIndex((item) => item === tag),
      1,
    );
  }

  selectedTag(event: MatAutocompleteSelectedEvent): void {
    this.tags.push(event.option.viewValue);
    this.tagInput.nativeElement.value = '';
    this.tagCtrl.setValue(null);
  }

  updateChangedModel?(model: any): void {
    /* noop */
  }
}
